module.exports = __webpack_public_path__ + "static/media/circulation.c82a1b6e.png";